import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import {LinkpileComponent as LinkpileCommon} from '../../common/linkpile/Linkpile';

function mapStateToProps(state) {
    return {
        details: state.destination.details,
        propertyType: state.destination.propertyType,
        linkPileTabs: state.destination.linkPileTabs,
        destination: state.destination
    };
}

export class LinkPileComponent extends Component {
    static propTypes = {
        details: PropTypes.shape({
            simpleName: PropTypes.string,
            fullName: PropTypes.string
        }),
        propertyType: PropTypes.string,
        linkPileTabs: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                links: PropTypes.arrayOf(
                    PropTypes.shape({
                        href: PropTypes.string,
                        title: PropTypes.string,
                        propertyCount: PropTypes.number,
                        lbsId: PropTypes.string,
                        type: PropTypes.string
                    })
                )
            })
        ),
        destination: PropTypes.object // eslint-disable-line react/forbid-prop-types
    };

    static defaultProps = {
        linkPileTabs: []
    };

    render() {
        const {
            details,
            linkPileTabs,
            propertyType,
            intl,
            destination
        } = this.props;
        const {formatMessage} = intl;

        const popularLinkPile =
            linkPileTabs && linkPileTabs.length > 0
                ? linkPileTabs.find((pile) => pile.name === 'popular')
                : null;

        const linkPile = popularLinkPile ? popularLinkPile.links : [];

        if (!linkPile.length) {
            return null;
        }

        return (
            <LinkpileCommon
                intl={intl}
                destination={{
                    ...destination,
                    linkPileTabs: [popularLinkPile]
                }}
                title={{
                    id: 'listings.title',
                    defaultMessage: 'UNTRANSLATED',
                    values: {
                        destinationName: <strong>{details.simpleName}</strong>,
                        propertyTypePluralNoArticle: formatMessage({
                            id: propertyType,
                            defaultMessage: 'UNTRANSLATED'
                        })
                    }
                }}
                hideTabs
            />
        );
    }
}

export const LinkPile = injectIntl(connect(mapStateToProps)(LinkPileComponent));
export default LinkPile;
